// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__hK_SQ","title":"News_title__CcTIg","dots":"News_dots__3nhvy","prev":"News_prev__2c16u","next":"News_next__uGSvt"};